import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment/moment';
import { getBodmasTestSeries, ModalToggle, isOpenModal, addBodmasTestSeries, updateBodmasTestSeries, isOpenStatusModal, statusToggle, statusUpdateBodmasTestSeries, statusDeleteBodmasTestSeries } from '../../store/bodmasTestSeriesSlice';
import { getBodmasCategory } from '../../store/bodmasCategorySlice';
import { successHandler } from '../../shared/_helper/responseHelper';

const BodmasTestSeriesTable = () => {
  const navigate = useNavigate();
  const storeVar = useSelector(state => state.bodmasTestseries);
  const bodmasCategoryVar = useSelector(state => state.bodmasCategory);
  const { layoutURL } = useContext(CustomizerContext);
  const dispatch = useDispatch();

  const toggle = () => dispatch(ModalToggle());
  const statusModalToggle = () => dispatch(statusToggle());
  const [stateStatus, setStateStatus] = useState('active');
  const [categoryIdFilter, setCategoryIdFilter] = useState('');
  const [submit, setSubmit] = useState(false);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingDelay = 800;

  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: null,
    editState: false,
    testSeriesId: '',
    title: '',
    categoryId: '',
    price: '',
    duration: '',
    correctMarks: '',
    inCorrectMarks: '',
    forNoOfQuestions: '',
    isSwitchable: 'true',
    publishDate: '',
  });

  useEffect(() => {
    dispatch(getBodmasTestSeries(formVar.limit, formVar.offset, formVar.status, formVar.keyword, categoryIdFilter));
    dispatch(getBodmasCategory(100, 0, 'active', ''));
  }, [dispatch, categoryIdFilter]);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1);
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }));
    dispatch(getBodmasTestSeries(formVar.limit, offset, formVar.status, formVar.keyword, categoryIdFilter));
  };

  const searchState = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, keyword: e.target.value }));
    searchWithDelay(e.target.value);
  };

  const searchWithDelay = (keyword) => {
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      dispatch(getBodmasTestSeries(formVar.limit, formVar.offset, formVar.status, keyword, categoryIdFilter));
    }, typingDelay);
    setTypingTimer(timer);
  };

  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, status: e.target.value }));
    dispatch(getBodmasTestSeries(formVar.limit, formVar.offset, e.target.value, formVar.keyword, categoryIdFilter));
  };

  const handleCategoryFilterChange = (e) => {
    setCategoryIdFilter(e.target.value);
    dispatch(getBodmasTestSeries(formVar.limit, formVar.offset, formVar.status, formVar.keyword, e.target.value));
  };

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true));
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      modalTitle: 'Edit Bodmas Test Series',
      testSeriesId: data._id,
      title: data.title,
      categoryId: data.categoryId?._id || data.categoryId || '',
      duration: data.duration,
      correctMarks: data.correctMarks,
      inCorrectMarks: data.inCorrectMarks,
      forNoOfQuestions: data.forNoOfQuestions,
      publishDate: data.publishDate,
      isSwitchable: String(data.isSwitchable ?? 'true'),
      price: data.price,
    }));
  };

  const AddToggleModal = () => {
    dispatch(isOpenModal(true));
    setSubmit(false);
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Bodmas Test Series',
      title: '',
      categoryId: '',
      duration: '',
      correctMarks: '',
      inCorrectMarks: '',
      mockTestId: '',
      forNoOfQuestions: '',
      publishDate: '',
      price: '',
      isSwitchable: 'true',
    }));
  };

  const onValueChange = (event) => {
    setStateStatus(event.target.value);
  };

  const statusToggleModal = (data) => {
    dispatch(isOpenStatusModal(true));
    setStateStatus(data.status);
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      mockTestId: data._id,
    }));
  };

  const submitMenu = () => {
    if (titleValid() || categoryValid() || priceValid() || positiveMarksValid() || negativeMarksValid() || durationValid() || forNoOfQuestionsValid() || publishValid()) {
      setSubmit(true);
      return null;
    }
    setSubmit(false);

    const payload = {
      title: formVar.title,
      categoryId: formVar.categoryId,
      price: formVar.price,
      duration: formVar.duration,
      correctMarks: formVar.correctMarks,
      inCorrectMarks: formVar.inCorrectMarks,
      isSwitchable: formVar.isSwitchable === 'true' || formVar.isSwitchable === true,
      forNoOfQuestions: formVar.forNoOfQuestions,
      publishDate: formVar.publishDate,
    };

    if (formVar.editState) {
      dispatch(updateBodmasTestSeries(formVar.testSeriesId, payload));
    } else {
      dispatch(addBodmasTestSeries(payload));
    }
  };

  const submitStatus = () => {
    dispatch(statusUpdateBodmasTestSeries({ id: formVar.mockTestId, status: stateStatus }));
  };

  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  };

  const categoryValid = () => {
    if (!formVar.categoryId) {
      return "Category is required";
    }
  };

  const priceValid = () => {
    if (formVar.price === null || formVar.price === undefined || formVar.price === '')
      return "Price is Required";
  };

  const positiveMarksValid = () => {
    if (!formVar.correctMarks) {
      return "Marks for Each Question is required";
    }
  };

  const negativeMarksValid = () => {
    if (formVar.inCorrectMarks === null || formVar.inCorrectMarks === undefined || formVar.inCorrectMarks === '') {
      return "Negative Marks is Required";
    }
  };

  const forNoOfQuestionsValid = () => {
    if (!formVar.forNoOfQuestions) {
      return "For Number Of Question is required";
    }
  };

  const durationValid = () => {
    if (!formVar.duration) {
      return "Duration is Required";
    }
  };

  const publishValid = () => {
    if (!formVar.publishDate) {
      return "Publish Date is Required";
    }
  };

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this test series!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        dispatch(statusDeleteBodmasTestSeries({ id: data._id, status: 'deleted' }));
      }
    });
  };

  const handleShare = (id) => {
    const url = `https://o2bodmas.com/test/${id}`;
    successHandler("Link Copied");
    navigator.clipboard.writeText(url)
      .catch(() => {
        console.error("Failed to copy link");
      });
  };

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="4">
                <Input
                  className="form-control"
                  placeholder='Search..'
                  type="text"
                  id="yourInputId"
                  value={formVar.keyword}
                  onChange={(e) => searchState(e)}
                />
              </Col>
              <Col md="3">
                <Input
                  className="form-control form-control-inverse btn-square"
                  name="selectCategory"
                  type="select"
                  value={categoryIdFilter}
                  onChange={handleCategoryFilterChange}
                >
                  <option value="">All Categories</option>
                  {bodmasCategoryVar?.categoryData?.map((cat, idx) => (
                    <option key={idx} value={cat._id}>{cat.name}</option>
                  ))}
                </Input>
              </Col>
              <Col md="3">
                <Input
                  className="form-control form-control-inverse btn-square"
                  name="select"
                  type="select"
                  value={formVar.status}
                  onChange={handleInputChange}
                >
                  <option value='active'>ACTIVE</option>
                  <option value='pending'>PENDING</option>
                </Input>
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Test
                  </Btn>
                </div>
              </Col>
            </Row>
          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Title</th>
                  <th scope='col'>Category</th>
                  <th scope='col'>Price</th>
                  <th scope='col'>Correct Marks</th>
                  <th scope='col'>InCorrect Marks</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.bodmasTestSeriesData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.categoryId?.name || '-'}</td>
                    <td>{item.price}</td>
                    <td>{item.correctMarks}</td>
                    <td>{item.inCorrectMarks}</td>
                    <td>
                      {item.status === 'active' && (
                        <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                          <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                          &nbsp; <span>Active</span>
                        </span>
                      )}
                      {item.status === 'pending' && (
                        <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                          <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                          &nbsp; <span>Pending</span>
                        </span>
                      )}
                      {item.status === 'DEACTIVE' && (
                        <span className={`font-danger w-50 rounded-1 p-1 me-2 d-flex align-items-center`}>
                          <i className="fa fa-times-circle-o fa-lg" aria-hidden="true"></i>
                          &nbsp; <span>{item.status}</span>
                        </span>
                      )}
                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-info action-icon'>
                          <i className="fa fa-share-alt fa-lg" onClick={() => handleShare(item._id)}></i>
                          <div className="tooltipCustom">Share</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={() => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-warning action-icon'>
                          <i className="fa fa-list-ol fa-lg" onClick={() => navigate('/bodmas-lessons/' + layoutURL + '?id=' + item._id)}></i>
                          <div className="tooltipCustom">Lessons</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-info action-icon'>
                          <i className="fa fa-toggle-on fa-lg" onClick={() => statusToggleModal(item)}></i>
                          <div className="tooltipCustom">Status Update</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={() => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {storeVar.totalBodmasTestSeries <= 0 && <Empty />}
        </Card>
        {storeVar.totalBodmasTestSeries > 0 && (
          <Pagination
            currentPage={formVar.currentPage}
            totalItem={storeVar.totalBodmasTestSeries}
            itemsPerPage={formVar.limit}
            showEllipsisAfter={true}
            visiblePageCount={3}
            onPageChange={pageChange}
          />
        )}
      </Col>

      {/* Add / Edit Modal */}
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} size={'lg'}>
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Test Name</Label>
            <Input
              className="form-control"
              type="text"
              placeholder='Enter Test Name'
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))}
              value={formVar.title}
            />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">Bodmas Category</Label>
            <Input
              className="form-control form-control-inverse btn-square"
              name="selectCategoryModal"
              type="select"
              value={formVar.categoryId}
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, categoryId: e.target.value }))}
            >
              <option value="">Select Bodmas Category</option>
              {bodmasCategoryVar?.categoryData?.map((item, index) => (
                <option key={index} value={item._id}>{item.name}</option>
              ))}
            </Input>
            {submit && categoryValid() ? <span className='d-block font-danger'>{categoryValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">Price</Label>
            <Input
              className="form-control"
              type="text"
              placeholder='Enter Price (Enter 0 For Free)'
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 6)}
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, price: e.target.value }))}
              value={formVar.price}
            />
            {submit && priceValid() ? <span className='d-block font-danger'>{priceValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">Marks for Each Question</Label>
            <Input
              className="form-control"
              type="text"
              placeholder='Enter Marks'
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)}
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, correctMarks: e.target.value }))}
              value={formVar.correctMarks}
            />
            {submit && positiveMarksValid() ? <span className='d-block font-danger'>{positiveMarksValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">Negative Marks </Label>
            <Input
              className="form-control"
              type="text"
              placeholder='Enter Negative Marks'
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)}
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, inCorrectMarks: e.target.value }))}
              value={formVar.inCorrectMarks}
            />
            {submit && negativeMarksValid() ? <span className='d-block font-danger'>{negativeMarksValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">For Number of Question </Label>
            <Input
              className="form-control"
              type="text"
              placeholder='Enter Number of Questions'
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)}
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, forNoOfQuestions: e.target.value }))}
              value={formVar.forNoOfQuestions}
            />
            {submit && forNoOfQuestionsValid() ? <span className='d-block font-danger'>{forNoOfQuestionsValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">Test Duration</Label>
            <Input
              className="form-control"
              type="text"
              placeholder='Enter Test Duration'
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)}
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, duration: e.target.value }))}
              value={formVar.duration}
            />
            {submit && durationValid() ? <span className='d-block font-danger'>{durationValid()}</span> : ""}

            <Label className="col-form-label mt-3">Select Date & Time</Label>
            <DatePicker
              selected={formVar.publishDate ? new Date(formVar.publishDate) : null}
              onChange={(publishDate) => setFormVar((prevFormVar) => ({ ...prevFormVar, publishDate }))}
              showTimeSelect
              placeholderText='Select Publish Date & Time'
              dateFormat="Pp"
              className="form-control"
              minDate={new Date()}
              filterTime={(time) => {
                const selectedDate = moment(formVar.publishDate);
                const now = moment();
                return selectedDate.isAfter(now.clone().startOf("day")) || moment(time).isSameOrAfter(now);
              }}
            />
            {submit && publishValid() ? <span className='d-block font-danger'>{publishValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">Lesson Switchable</Label>
            <Input
              className="form-control form-control-inverse btn-square"
              name="select"
              type="select"
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, isSwitchable: e.target.value }))}
              value={formVar.isSwitchable}
            >
              <option value='true'>YES</option>
              <option value='false'>NO</option>
            </Input>
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

      {/* Status Modal */}
      <CommonModal isOpen={storeVar.isStatusOpenModal} title={'Status'} toggler={statusModalToggle}>
        <Col>
          <div className='d-flex m-15 m-checkbox-inline justify-content-center custom-radio-ml'>
            <div className='radio radio-primary'>
              <Input
                id='radioinline1'
                type='radio'
                className="radio_animated"
                name='radio1'
                checked={stateStatus === 'active'}
                onChange={onValueChange}
                value='active'
              />
              <Label className='mb-0' for='radioinline1'>
                <span className='digits'>ACTIVE</span>
              </Label>
            </div>
            <div className='radio radio-primary'>
              <Input
                id='radioinline3'
                type='radio'
                className="radio_animated"
                name='radio3'
                checked={stateStatus === 'pending'}
                onChange={onValueChange}
                value='pending'
              />
              <Label className='mb-0' for='radioinline3'>
                <span className='digits'>PENDING</span>
              </Label>
            </div>
          </div>
        </Col>
        <ModalFooter className='justify-content-center'>
          <Btn attrBtn={{ color: 'secondary', onClick: statusModalToggle }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitStatus }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default BodmasTestSeriesTable;
